const PreLaunchFlag = () => (
  <div className="property-card-flag property-card-flag--coming-soon" data-test-reference="pre-order-flag">
    <div>COMING</div>
    <div>SOON</div>
  </div>
);

export default PreLaunchFlag;
